import { Spin } from 'antd';
import { GraphChart } from '@components/charts';
import { useWidgetData } from '@hooks/useWidgetData';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

interface Config {
  forceDirected?: boolean;
}
interface GraphNode {
  name: string;
  category?: number;
  symbolSize?: number;
}
interface GraphLink {
  source: string;
  target: string;
  value?: number;
}
interface Data {
  nodes: GraphNode[];
  links: GraphLink[];
  categories?: Array<{ name: string }>;
}

function GraphWidget({ instance }: WidgetRenderProps<Config>) {
  const { data, isLoading } = useWidgetData<Data>(
    instance.id, 'graph', instance.config as Record<string, unknown>, instance.refreshInterval,
  );
  if (isLoading) return <Spin />;
  return <GraphChart nodes={data?.nodes ?? []} links={data?.links ?? []} categories={data?.categories} forceDirected={instance.config.forceDirected} />;
}

export const graphWidgetDef: WidgetDefinition<Config> = {
  type: 'graph',
  name: 'Graph / Network',
  description: 'Node-link relationships',
  icon: 'ShareAltOutlined',
  category: 'chart',
  defaultTitle: 'Graph',
  defaultConfig: { forceDirected: true },
  minW: 4, minH: 5, defaultW: 6, defaultH: 7,
  component: GraphWidget,
  settingsSchema: { fields: [{ key: 'forceDirected', label: 'Force-directed layout', type: 'boolean' }] },
};
